var CurrentUser = require("lib/account/CurrentUser");

var moment = require('moment');

var CommentBox = require("components/social/comments/CommentBox");
var LogRow = require('components/reading/logs/LogRow.js');
var PaywallModal = require("components/users/teachers/PaywallModal");
var Features = require("lib/account/Features");
var ReactTooltip = require("react-tooltip");

class EachMonthLogTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			monthDataHidden: (!props.initExpanded && props.initExpanded != undefined)
		}
	}

	showCommentPaywall() {
		this.refs.commentPaywallModal.show();
	}

	toggleShowLogData() {
		if (this.state.monthDataHidden) {
			this.setState({ monthDataHidden: false })
		} else {
			this.setState({ monthDataHidden: true })
		}
	}

	renderCommentBox() {
		var log = _.first(this.props.logs);
		if (!log) { return; }

		var initialCollapsed = CurrentUser.isAdmin();
		var subjectID = log.user_id + "-" + "logs-month-" + this.props.month;
		if (!this.props.hideCommentBox) {
			var commentBox = (
				<CommentBox subjectID={ subjectID } subjectType={ "MonthLogTable" }
					userID={ log.user_id } initialCollapsed={ initialCollapsed }
					blockFirstComment={ CurrentUser.isStudent() }
					showPaywallModal={ this.showCommentPaywall } noSuggestedComments />
			)
		}

		return (
			<div className="commentWrap">
				{ commentBox } 
				<PaywallModal ref="commentPaywallModal" featureType={ PaywallModal.QUIZ_FEATURES } />
			</div>
		)

	}

	render() {
		var sumMins = 0;
		var sumPages = 0;

		if (this.state.monthDataHidden) {
			var sum = 0;
			_.each(this.props.logs, function(log, index){
				//here we used .each instead of .map because we don't have to use return
				//look up difference between the two
				sumMins = sumMins + log.minutes;
				sumPages = sumPages + log.pages;
			});

			var expandLink = (
				<a href="#" className="expandLink" onClick={ $wr.nope } >
					View
				</a>
			)

		} else {

			var sum = 0;
			var logs = _.sortBy(this.props.logs, "log_date");
			var logRows = _.map(logs, function(log, index){
				sumMins = sumMins + log.minutes;
				sumPages = sumPages + log.pages;

				return (
					<LogRow log={ log } key={ log.id } condensedLayout={ this.props.condensedLayout } />
				)
			}.bind(this));
		}

		if (this.props.showFullData) {
			var monthName = moment(this.props.month).format('MMMM YYYY');
			var tableHeaders= (
				<tr className="outerTitles clickable" onClick= { this.toggleShowLogData }>
					<th className="dateTitle" colSpan={ 2 }>{ monthName }</th>
					<th className="minuteCell">
						<p className="infoContainer">{ sumMins || "-" }</p>
						<span className="sectionLabel">Total Minutes</span>
					</th>
					<th className="pageCell">
						<p className="infoContainer">{ sumPages || "-" }</p>
						<span className="sectionLabel">Total Pages</span>
					</th>
					<th className="editCell">{ expandLink }</th>
					<th></th>
				</tr>	
			)
			if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
				var commentBox = this.renderCommentBox();
			}
		}

		return(
			<div className="monthLogTable">

				<table className="logTable">
					<tbody>
						{ tableHeaders }
						{ logRows }
					</tbody>
				</table>

				{ commentBox }
			</div>

		)
	}
};

EachMonthLogTable.propTypes = StrictPropTypes({
	logs: PropTypes.array.isRequired,
	month: PropTypes.string,
	initExpanded: PropTypes.bool,
	hideCommentBox: PropTypes.bool,
	showFullData: PropTypes.bool,
	condensedLayout: PropTypes.bool,
});


module.exports = EachMonthLogTable;



// WEBPACK FOOTER //
// ./modules/components/reading/logs/MonthLogTable.js